import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	OnDestroy,
} from "@angular/core";
import { HomeService } from "./home.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { groupBy, head, map as _map, orderBy, cloneDeep } from "lodash";
import * as moment from "moment";
import { SocketService } from '../shared/services/socket.service';
import { SliceRecordChanges } from "auxilium-connect/dist/v1/src/socket/socket.defs";

@Component({
	selector: "app-home",
	templateUrl: "./home.component.html",
	styleUrls: ["./home.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit, OnDestroy {
	call: any;
	phone: any;
	tableData: any;
	groupedData = [];
	groupedKeys = [];
	tomorrowToggle: boolean = false;
	method = 'Call';
	subscription: any;
	callToggle: boolean = false;
	methodDisplayView = 'Calling';

	constructor(
		public appstore: HomeService,
		public snackbar: MatSnackBar,
		public cdr: ChangeDetectorRef,
		private socketService: SocketService,
	) { }


	ngOnInit(): void {
		this.getCalls();
		this.subscription = this.socketService.onRecordChanges(51422, 'dorwin').subscribe((changes: SliceRecordChanges) => {
			this.getCalls();
		});
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	getCalls() {
		this.appstore.getCalls().subscribe((w: any) => {
			this.tableData = w;
			// w = orderBy(w, (t) => t.id, 'desc');
			// this.filterData(w);
			this.cdr.detectChanges();
		});
	}

	filterData(data) {
		this.groupedData = groupBy(data, (x) => x.PhoneNumber);
		this.groupedData = orderBy(this.groupedData, (t) => t[0].id, 'desc');
		console.log(this.groupedData);
		this.groupedKeys = Object.keys(this.groupedData);
		this.cdr.detectChanges();

	}
	callMethod() {
		this.formatData('Call');
	}
	formatData(method) {
		let filteredData = this.tableData.filter(data => data.PhoneNumber == this.phone);
		if (filteredData.length > 0) {
			filteredData[0].Call = new Date();
			filteredData[0].Method = method;
			this.appstore
				.updateData(filteredData[0])
				.subscribe((w) => {
					this.call = "";
					this.phone = "";
					this.getCalls();
					this.cdr.detectChanges();
				});

		} else {
			this.appstore
				.insertData({ Call: new Date(), PhoneNumber: this.phone, Method: method })
				.subscribe((w) => {
					this.call = "";
					this.phone = "";
					this.getCalls();
					this.cdr.detectChanges();
				});
		}
	}
	submit() {
		this.formatData('Text');

	}

	getDateDifference(date) {
		const dateB = moment(new Date());
		const dateC = moment(date);

		return dateB.diff(dateC, "days");
	}
	onKeydown(event) {
		if ((event.keyCode == 13) && (this.phone)) {
			this.appstore
				.getDoNotCalls(this.phone)
				.subscribe((w: any) => {
					if (w.length > 0) {
						alert(this.phone + ' is on DO NOT CALL list.');
						this.phone = '';
					} else {
						this.formatData(this.method);
						this.cdr.detectChanges();
					}
				});
		}
	}
	toggleChange() {
		if (this.callToggle) {
			this.method = 'Call';
			this.methodDisplayView = 'Calling';
		} else {
			this.method = 'Text';
			this.methodDisplayView = 'Texting';
		}
	}
	dateSet() {
		let date;
		if (this.tomorrowToggle) {
			date = new Date();
			date.setDate(date.getDate() + 1);
		} else {
			date = new Date();
		}
		this.call = date;
		if (this.phone) {
			this.submit();
		}
	}
}
